export default __webpack_public_path__ + "static/media/nft-alpha.d46c37df.jpg";